import axios from "axios";

// let baseURL = "https://ipachong.com/api" //以前的go后端
let baseURL = "https://api.ipachong.com" //新的express.js后端
// let baseURL = "http://localhost:9000"       //本地测试

const _axios = axios.create({
    baseURL: baseURL,
})

//请求拦截
_axios.interceptors.request.use((requestConfig) => {
    //token
    const token = window.location.search.match(/token=(.*)&/);
    const user_id = window.location.search.match(/user_id=(.*)/);
    console.log("token", token);
    console.log("user_id", user_id);
    if (token) {
        localStorage.setItem("token", token ? token[1] : "");
        localStorage.setItem("user_id", user_id ? user_id[1] : "");
    }
    requestConfig.headers.Authorization = localStorage.getItem("token")
    console.log("请求拦截", requestConfig)
    return requestConfig
}, (error) => {
    return Promise.reject(error)
})

//响应拦截
_axios.interceptors.response.use((response) => {
    // 2xx 范围内的状态码都会触发该函数。
    return response;
}, (error) => {
    // 超出 2xx 范围的状态码都会触发该函数。
    //console.log("响应拦截", error.response.status)
    const status = error.response.status
    if (status === 401) {
        //缺少Token 或 已经过期
    } else if (status === 403) {
        //权限不足

    }
    return Promise.reject(error);
})

export default _axios
